import {Snackbar} from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import React, {CSSProperties} from 'react';
import 'Shared/components/PagedView/Table/TableLoadingRow.sass';

type LoadingRowProps = {
  open: boolean;
  handleChange: any;
  style: CSSProperties;
  severity: any;
  msg: string;
  autoHide: boolean;
  isMobile: boolean;
};

const MaximumRow = (props: LoadingRowProps) => (
  <Snackbar
    open={props.open}
    autoHideDuration={props.autoHide ? 6000 : null}
    onClose={props.handleChange}
    style={{
      left: props.isMobile ? '4%' : '50%',
      width: props.isMobile ? '92%' : '50%',
      top: props.style.top,
      position: props.style.position,
      marginTop: '2%',
    }}
  >
    <Alert onClose={props.handleChange} severity={props.severity} className="limit-records-40">
      {props.msg}
    </Alert>
  </Snackbar>
);

export default MaximumRow;
